// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__21nAh","resendInfoText":"OnGoingPaymentBox_resendInfoText__208k-"};